import { buildTemplateEntryHref } from '@/lib/routing/template-entry';

/** 已核对公开生产模板及其输入合同，避免把单件换装送入多件搭配任务。 */
export const FASHION_SEO_TEMPLATES = {
  aiFashionModelGenerator: 'cdf7954a-8848-4864-b5e9-596271977403',
  aiLookbookGenerator: 'fc9418f7-08f6-4d5c-97db-253d17212000',
} as const;

export function buildSeoLandingStartHref(pageKey: string, sourceLanding: string, locale: string): string {
  const templateId = Object.prototype.hasOwnProperty.call(FASHION_SEO_TEMPLATES, pageKey)
    ? FASHION_SEO_TEMPLATES[pageKey as keyof typeof FASHION_SEO_TEMPLATES]
    : null;
  if (templateId) return buildTemplateEntryHref(templateId, { locale, sourceLanding });
  const destination = new URLSearchParams();
  if (pageKey === 'aiOutfitGenerator') destination.set('capability', 'outfitMix');
  if (locale === 'zh') destination.set('lang', 'zh');
  const redirect = `/explore${destination.size ? `?${destination.toString()}` : ''}`;
  const params = new URLSearchParams({ redirect, login: '1', source_landing: sourceLanding });
  if (locale === 'zh') params.set('lang', 'zh');
  return `/login?${params.toString()}`;
}
